<template>
    <div>

        <button class=" text-blue-700" @click="open" aria-label="Open menu">
            <svg width="28"
                 class="stroke-current"
                 height="22"
                 viewBox="0 0 28 22"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M0 21H24"
                      stroke-width="2"/>
                <path d="M0 1H24"
                      stroke-width="2"/>
                <path d="M5 11L28 11"
                      stroke-width="2"/>
            </svg>

        </button>
        <transition name="fade">

        <div class="bg-blue-700 text-white w-full h-full fixed inset-0" v-show="isOpen">
            <header class=" lg:sticky top-0 w-full z-50 mb-16">
                <div class="container pt-4">
                    <div class="xl:-mx-20 flex justify-between">
                        <logo class="text-white"></logo>
                        <button class=" text-white" @click="close">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-8 w-8" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
                        </button>


                    </div>
                </div>
            </header>
            <div class="container">
                <div class="flex flex-wrap justify-end">
                    <div class="md:w-1/2">
                        <nav class="text-3xl md:text-5xl leading-none">
                            <slot></slot>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "hamburgerNavigation",

        data: function() {
            return {
                isOpen: false
            }
        },
        created() {
            window.addEventListener('keydown',(event)=>{
                if(event.keyCode === 27 && this.isOpen){
                    this.close();
                }
            });
        },
        methods: {
            open: function(){
                this.isOpen = true;
                document.body.classList.add('overflow-hidden');
            },
            close: function() {
                this.isOpen = false;
                document.body.classList.remove('overflow-hidden');
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
